<!-- TODO: fields that are in the nls transaction model that aren't displayed in @product view are commented out -->

<div class="page-container">
  <div class="transaction-details-container">

    <!-- Back Button -->
    <div class="back-button" (click)="goBack()">
      <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M14.0667 1.69218C14.1839 1.57497 14.25 1.41576 14.25 1.25C14.25 1.08424 14.1842 0.925269 14.0669 0.808058L14.0615 0.802728C13.9448 0.689 13.788 0.625 13.625 0.625C13.4592 0.625 13.3003 0.690848 13.1831 0.808058L6.93306 7.05806C6.81585 7.17527 6.75 7.33424 6.75 7.5C6.75 7.66576 6.81585 7.82473 6.93306 7.94194L13.1831 14.1919C13.3003 14.3092 13.4592 14.375 13.625 14.375C13.7908 14.375 13.9497 14.3092 14.0669 14.1919C14.1842 14.0747 14.25 13.9158 14.25 13.75C14.25 13.5842 14.1842 13.4253 14.0669 13.3081L8.25888 7.5L14.0667 1.69218Z"
        fill="#99AEBC"></path>
      </svg>
      <span class="back-text">Back</span>
    </div>

    <h1 class="page-header padder">Transaction Details</h1>


    <!-- Loading Spinner -->
    @if (isLoading) {
      <div class="loading-container">
        <mat-spinner diameter="50"></mat-spinner>
      </div>
    }

    <!-- Transaction Information Section -->
    @if (nlsTransaction && !isLoading) {
      <div class="details-info">
        <div class="details-left">
          <div class="info-row">
            <span class="label">Supplier Name:</span>
            <span class="value">{{ nlsTransaction.supplier_company }}</span>
          </div>
          <div class="info-row">
            <span class="label">Origination Date:</span>
            <span class="value">{{ nlsTransaction.origination_date | date: 'MM/dd/yyyy' }}</span>
          </div>
          <div class="info-row">
            <span class="label">Loan ID:</span>
            <span class="value">{{ nlsTransaction.loan_number }}</span>
          </div>
          <div class="info-row">
            <span class="label">Promotion Description:</span>
            <span class="value">{{ nlsTransaction.plan_desc }}</span>
          </div>
          <div class="info-row">
            <span class="label">Next Payment Due:</span>
            <span class="value">{{ nlsTransaction.next_payment_due| date: 'MM/dd/yyyy' }}</span>
          </div>
          <div class="info-row">
            <span class="label">Current Balance:</span>
            <span class="value">{{ nlsTransaction.formattedCurrentBalance }}</span>
          </div>
          <div class="info-row">
            <span class="label">Request Memo:</span>
            <span class="value">{{ nlsTransaction.displayRequestMemo }}</span>
          </div>
          <div class="info-row">
            <span class="label">
              <a class="button-link" (click)="onTransactionAuthorizationClick()">
                Transaction Authorization
              </a>
            </span>
          </div>
        </div>
        <!-- Invoices Card -->
        <div class="invoice-files">
          <h3>Invoices</h3>
          <!-- Loading invoices template -->
          @if (invoiceFiles == undefined) {
            <div class="loading-invoices">
              <mat-spinner diameter="30" color="accent"></mat-spinner>
            </div>
          }
          <!-- Invoices present -->
          @if (invoiceFiles != undefined && invoiceFiles.length > 0) {
            <div class="details-files">
              @for (file of invoiceFiles; track file; let index = $index) {
                <a (click)="onOpenFile(index)" target="_blank">{{ file.name }}</a>
              }
            </div>
          }
          <!-- No invoices template -->
          @if (invoiceFiles != undefined && invoiceFiles.length === 0) {
            <div class="no-invoice-files">
              <span>No invoice files available</span>
            </div>
          }
        </div>
      </div>
    }


    <!-- Pending Payments Table -->
    <!-- Removed Pending Payment Table as per TBYND-667
    <div class="pending-payments-section" *ngIf="nlsTransaction && !isLoading">
      <h3 style="text-align:left;">Pending Payments</h3>

      <app-pending-payments-table [transaction_id]="nlsTransaction.transaction_id"></app-pending-payments-table>
    </div>
    -->

    <!-- Transaction Table -->
    @if (nlsTransaction && !isLoading) {
      <div class="transactions-section">
        <h3>Transactions</h3>
        <app-transaction-details-table [transaction_id]="nlsTransaction.transaction_id"></app-transaction-details-table>
      </div>
    }
  </div>
</div>